export default {
  timeout: 10 * 1000,
  // host: "https://qqcnewapi.qzappapia456.com",
  host: "https://api.d8c0964.com", // 正式
  webKey: "luckygogointch-intech",
  endPoint: "H5",
};
